export const technicalForm = {
  add: {
    label: "Ajouter un formulaire technique",
    title: "Ajouter un formulaire technique",
  },
  delete: {
    label: "Supprimer le formulaire technique",
    disabled:
      "Ce formulaire technique ne peut pas être supprimé puisqu'il est lié à des types d'actifs.",
  },
  emptyForm: "Aucun formulaire technique n'est disponible",
  form: {
    name: {
      label: "Nom",
    },
    usedInAssetType: {
      label: "Utilisé par ces types d'actifs",
    },
  },
};
